import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void; // setIsOpen関数を受け取る
  title: string;
  description: string;
}

function NotConfirmedDialog({ isOpen, setIsOpen }: Props) {
  const handleCloseDialog = () => {
    setIsOpen(false);
  };
  return (
    <Dialog open={isOpen} onClose={handleCloseDialog}>
      <DialogTitle>確認</DialogTitle>
      <DialogContent>
        <DialogContentText>
          個人管理サービスを利用されない場合、AIを利用した診療は行われず、提供できる医療が少なくなり、品質が低下する場合がありますがよろしいでしょうか？
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} variant="contained">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NotConfirmedDialog;
